export default {
  login: 'Login',
  logout: 'Logout',
  loginWith: 'Login with Nextcloud',
  loginError: 'Login failed. Please try again.',
  sessionExpired: 'Your session has expired. Please login again.'
};
